/*eslint-disable*/
import React, { Component } from 'react';
import moment from 'moment';
import { Col, FormGroup } from 'react-bootstrap';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Field, reduxForm, propTypes, formValueSelector, change } from 'redux-form';
import { PropTypes } from 'prop-types';
import ModalWindow from '../../../../utils/modalwindow';
import ModalTable from '../../../../utils/modaltable';
import normalizePhone from '../../../../utils/functions/normalizePhone';
import {
  forms,
  countries,
  states,
  canadianprovinces,
  gray,
  orange,
  blue,
  warning,
  style,
  StatusDescription
} from '../../../../utils/constants';
import { isEmpty } from '../../../../utils/functions';
import {
  fetchMember,
  fetchEvent,
  fetchCenter,
  fetchActiveSeasons,
  saveEventInfo,
  resetWizardState,
  resetEventLocation,
  resetEventDirector,
  setSearchMode,
  setCenter,
} from '../../../../redux/actions/action_event';
import { types } from '../../../../redux/actions';
import { renderField } from '../../../../modules/components/fieldcomponent';
import { renderOptionsField } from '../../../../modules/components/fieldoptioncomponent';
import { renderDatePickerField } from '../../../../modules/components/datepickercomponent';
import { renderSelectField } from '../../../../modules/components/selectfieldcomponent';
import { renderInputWithSearchField } from '../../../../modules/components/inputwithsearchfieldcomponent';
import { STEP_SEQUENCE } from '../../logic';
import EventInfoFields from './fields';
import 'react-datepicker/dist/react-datepicker.css';
import '../../../../utils/css/nospinner.css';

const FormName = forms.eventinfo;

const spanClassName = `col-sm-12`

const sectionBorder = {
  border: `1px solid ${gray}`,
  padding: '15px',
  marginRight: '0px',
  marginBottom: '15px'
}

class EventInfo extends Component {

  static propTypes = {
    ...propTypes
  }
  constructor(props, context) {
    super(props, context)
    this.onHandleGetCenterInfo = this.onHandleGetCenterInfo.bind(this)
    this.onHandleGetCenterInfoByNumber = this.onHandleGetCenterInfoByNumber.bind(this)
    this.handleGetMemberInfo = this.handleGetMemberInfo.bind(this)
    this.handleResetEventLocation = this.handleResetEventLocation.bind(this)
    this.handleResetEventDirector = this.handleResetEventDirector.bind(this)
    this.setSeasons = this.setSeasons.bind(this)
    this.isInfoEqual = this.isInfoEqual.bind(this)
    this.saveEventInfo = this.saveEventInfo.bind(this)
    this.generateUpdateErrors = this.generateUpdateErrors.bind(this)
    this.handleNegativeNumbers = this.handleNegativeNumbers.bind(this)
    this.handleNotToExceedLengthPrefix = this.handleNotToExceedLengthPrefix.bind(this)
    this.handleNotToExceedLengthSuffix = this.handleNotToExceedLengthSuffix.bind(this)
  }

  componentDidMount() {
    this.props.dispatch(resetWizardState(STEP_SEQUENCE.EventInfo));
  }

  componentWillUpdate() {
    const { searchMode, dispatch } = this.props
    if (searchMode === true) {
      dispatch(setSearchMode(false));
    }
  }

  saveEventInfo() {
    const { dispatch } = this.props
    const { isInfoEqual } = this
    const {
      saveEventInfo, eventname, eventaddress, eventcity, eventzipcode, eventstate, eventcountry, eventseason, startdate, enddate, centername,
      centercertnumber, memberidsuffix, memberidprefix, directorname, directorssoemail, eventemail, directorphone, directorcountry,
      directoraddress1, directoraddress2, directorcity, directorstate, directorzipcode, eventId, prestineinfo
    } = this.props

    const saveInfo = !isInfoEqual(prestineinfo, this.props)

    if (saveInfo === true) {
      const centerAddress = {
        addressLine1: eventaddress,
        city: eventcity,
        state: eventstate,
        zipcode: eventzipcode,
        country: eventcountry
      }
      const directorAddress = {
        addressLine1: directoraddress1,
        addressLine2: directoraddress2,
        city: directorcity,
        state: directorstate,
        zipcode: directorzipcode,
        country: directorcountry
      }
      const info = {
        eventId: eventId,
        seasonId: eventseason,
        step: 1,
        name: eventname,
        startDate: startdate,
        endDate: enddate,
        centerCertificationNumber: centercertnumber,
        centerName: centername,
        centerAddress,
        directorName: directorname,
        directorPhoneNumber: directorphone,
        directorUsbcMemberId: `${memberidprefix}-${memberidsuffix}`,
        directorSSOEmail: directorssoemail,
        eventEmail: eventemail,
        directorAddress
      }
      dispatch(change(FormName, 'savingdata', true))
      saveEventInfo(info)
    }
    else {
      this.props.onComponentStateSaved(true)
    }
  }

  handleResetEventLocation(event) {
    const fieldname = event.target.name
    const { dispatch, centercertnumber, centername, eventaddress, eventcity, eventstate, eventzipcode } = this.props

    if (!isEmpty(centercertnumber) && fieldname !== EventInfoFields.CENTER_CERTNUMBER) {
      dispatch(change(FormName, EventInfoFields.CENTER_CERTNUMBER, ''))
    }
    if (!isEmpty(centername) && fieldname != EventInfoFields.CENTER_NAME) {
      dispatch(change(FormName, EventInfoFields.CENTER_NAME, ''))
    }
    if (!isEmpty(eventaddress)) {
      dispatch(change(FormName, EventInfoFields.EVENT_ADDRESS, ''))
    }
    if (!isEmpty(eventcity)) {
      dispatch(change(FormName, EventInfoFields.EVENT_CITY, ''))
    }
    if (!isEmpty(eventstate)) {
      dispatch(change(FormName, EventInfoFields.EVENT_STATE, ''))
    }
    if (!isEmpty(eventzipcode)) {
      dispatch(change(FormName, EventInfoFields.EVENT_ZIPCODE, ''))
    }
  }
  handleResetEventDirector() {
    const { dispatch, directorname, directorssoemail, eventemail, directorphone, directorcountry, directoraddress1,
      directoraddress2, directorcity, directorstate, directorzipcode, nomembersfound
    } = this.props

    if (!isEmpty(directorname)) {
      dispatch(change(FormName, EventInfoFields.DIRECTOR_NAME, ''))
    }
    if (!isEmpty(directorssoemail)) {
      dispatch(change(FormName, EventInfoFields.DIRECTOR_SSOEMAIL, ''))
    }
    if (!isEmpty(eventemail)) {
      dispatch(change(FormName, EventInfoFields.EVENT_EMAIL, ''))
    }
    if (!isEmpty(directorphone)) {
      dispatch(change(FormName, EventInfoFields.DIRECTOR_PHONE, ''))
    }
    if (!isEmpty(directorcountry)) {
      dispatch(change(FormName, EventInfoFields.DIRECTOR_COUNTRY, ''))
    }
    if (!isEmpty(directoraddress1)) {
      dispatch(change(FormName, EventInfoFields.DIRECTOR_ADDRESS1, ''))
    }
    if (!isEmpty(directoraddress2)) {
      dispatch(change(FormName, EventInfoFields.DIRECTOR_ADDRESS2, ''))
    }
    if (!isEmpty(directorcity)) {
      dispatch(change(FormName, EventInfoFields.DIRECTOR_CITY, ''))
    }
    if (!isEmpty(directorstate)) {
      dispatch(change(FormName, EventInfoFields.DIRECTOR_STATE, ''))
    }
    if (!isEmpty(directorzipcode)) {
      dispatch(change(FormName, EventInfoFields.DIRECTOR_ZIPCODE, ''))
    }
    if (nomembersfound) {
      dispatch(change(FormName, 'nomembersfound', false))
    }
  }
  onHandleGetCenterInfo(event) {
    event.preventDefault()
    const { dispatch } = this.props
    dispatch(setSearchMode(true));
    const searchvalue = this.props.centername
    dispatch(fetchCenter(types.Center.SEARCH_BY_NAME, searchvalue))
  }
  onHandleGetCenterInfoByNumber(event) {
    event.preventDefault()
    const { dispatch } = this.props
    const searchvalue = this.props.centercertnumber
    dispatch(fetchCenter(types.Center.SEARCH_BY_NUMBER, searchvalue))
  }
  handleGetMemberInfo(event) {
    const { dispatch, memberidprefix, memberidsuffix } = this.props
    event.preventDefault()
    dispatch(setSearchMode(true));
    dispatch(fetchMember(memberidprefix, memberidsuffix))
  }

  handleChange(e) {
    const re = /^[0-9\b]+$/;
    const value = e.target.value
    const id = e.target.id

    if ((e.target.value == '' || re.test(e.target.value)) && (value.length < 4)) {
      this.setState({ [id]: value })
    }
  }
  isInfoEqual(original, current) {
    let equal = true

    if ((original != undefined) && (current != undefined)) {
      if (original.seasonId != current.eventseason) {
        equal = false
      }
      if (original.eventname != current.eventname) {
        equal = false
      }
      if (original.startdate != current.startdate) {
        equal = false
      }
      if (original.enddate != current.enddate) {
        equal = false
      }
      if (original.centername != current.centername) {
        equal = false
      }
      if (original.centercertnumber != current.centercertnumber) {
        equal = false
      }
      if (original.memberidsuffix != current.memberidsuffix) {
        equal = false
      }
      if (original.memberidprefix != current.memberidprefix) {
        equal = false
      }
      if (original.eventemail != current.eventemail) {
        equal = false
      }
      if (original.directorssoemail != current.directorssoemail) {
        equal = false
      }
    }
    else {
      equal = false
    }

    return equal

  }

  setSeasons() {
    const { seasons, roleName } = this.props
    const activeseasons = []
    seasons.map(function (season) {
      //check if season end date is expired
      if (moment().diff(season.endDate, 'days') <= 0) {
        activeseasons.push({
          name: season.description,
          abbreviation: season.id.toString(),
          isCurrent: season.isCurrent
        })
      }
    })
    return activeseasons
  }

  generateUpdateErrors(eventInfoErrors) {
    const error = eventInfoErrors.map((key, index) => {
      return (<li key={index} style={{ color: warning }}>{this.props.updateErrors[key]}</li>)
    })
    return error;
  }

  handleNegativeNumbers(evt) {
    if (evt.which === 109 || evt.which === 189) {
      evt.preventDefault();
    }
  }

  handleNotToExceedLengthPrefix(evt) {
    const { value } = evt.target;
    if ((value.length > 4)) {
      return evt.target.value = value.substring(0, 4);
    }
  }

  handleNotToExceedLengthSuffix(evt) {
    const { value } = evt.target;
    if ((value.length > 7)) {
      return evt.target.value = value.substring(0, 7);
    }
  }

  render() {

    const {
      handleSubmit, eventcountry, eventseason, centername, centercertnumber,
      searchMode, norecordsfound, dispatch, centers, memberidsuffix, memberidprefix, directorcountry,
      saveComponentState, componentStateSaved, currentWizardStep, updateErrors, nomembersfound, roleName, status
    } = this.props

    const isAdministrator = roleName == 'Administrator';
    const multiplecenters = (isEmpty(centers) === false) && (centers.length > 1)
    const activeSeasons = this.setSeasons()
    const countrystates = directorcountry === 'US' ? states : canadianprovinces
    const eventInfoErrors = Object.keys(updateErrors);

    if (currentWizardStep === STEP_SEQUENCE.EventInfo) {
      if ((saveComponentState === true) && (componentStateSaved === false)) {
        this.saveEventInfo();
      }
      if (componentStateSaved === true) {
        this.props.onComponentStateSaved(componentStateSaved)
      }
      if (eventInfoErrors.length > 0) {
        this.props.onComponentStateSaved(false)
      }
    }
    return (
      <div style={{ marginTop: '1%' }}>
        {
          norecordsfound &&
          (<ModalWindow
            title='No records found'
            message='We could not find any records matching the search criteria specified.'
            trigger='norecordsfound'
            dispatch={dispatch} />)
        }
        {
          (multiplecenters === true) && (<ModalTable
            title='Multiple centers found'
            records={centers}
            dispatch={dispatch}
            setCenter={setCenter} />)
        }
        <form id='eventinfo' onSubmit={handleSubmit} className="form-horizontal" sm={12} style={{ padding: '0', margin: '0' }}>
          {
            (eventInfoErrors.length > 0) &&
            (
              <Col sm={12} style={sectionBorder}>
                <h4 style={{ color: warning }}>* Please correct the following errors to proceed:</h4>
                <ul>
                  {
                    this.generateUpdateErrors(eventInfoErrors)
                  }
                </ul>
              </Col>
            )
          }
          {
            (
              <Col md={12} lg={6} style={{ border: `1px solid ${gray}`, padding: '15px', marginRight: '0px', marginBottom: '15px' }} >
                <FormGroup style={{ padding: '0 0 15px 25px', margin: '0' }}>
                  <h4 className='text-left' style={{ color: blue }}>{' '}Event Dates and Location</h4>
                </FormGroup>
                <Field
                  type='text'
                  text='1'
                  name="wizardstep"
                  component="input"
                  className="hidden"
                />
                <Field
                  label='Season'
                  labelattrs={style.lblattrs}
                  inputattrs={style.inputattrs}
                  name={EventInfoFields.SEASON}
                  id={EventInfoFields.SEASON}
                  values={activeSeasons}
                  component={renderOptionsField}
                  defaultvalue={eventseason}
                  disabled={(!isAdministrator && (status == StatusDescription.Completed || status == StatusDescription.Canceled)) || (saveComponentState === true)}
                />
                <Field
                  label='Event Name'
                  labelattrs={style.lblattrs}
                  inputattrs={style.inputattrs}
                  name={EventInfoFields.NAME}
                  component={renderField}
                  placeholder='Type event name'
                  disabled={(!isAdministrator && (status == StatusDescription.Completed || status == StatusDescription.Canceled)) || (saveComponentState === true)}
                />
                <Field
                  label='Start Date'
                  labelattrs={style.lblattrs}
                  inputattrs={style.inputattrs}
                  title='Event start date'
                  name={EventInfoFields.STARTDATE}
                  component={renderDatePickerField}
                  placeholder='mm-dd-yyyy'
                  disabled={(!isAdministrator && (status == StatusDescription.Completed || status == StatusDescription.Canceled)) || (saveComponentState === true)}
                />
                <Field
                  label='End Date'
                  labelattrs={style.lblattrs}
                  inputattrs={style.inputattrs}
                  name={EventInfoFields.ENDDATE}
                  title='Event end date'
                  component={renderDatePickerField}
                  placeholder='mm-dd-yyyy'
                  disabled={(!isAdministrator && (status == StatusDescription.Completed || status == StatusDescription.Canceled)) || (saveComponentState === true)}
                />
                <Field
                  label='Center Cert. #'
                  labelattrs={style.lblattrs}
                  inputattrs={style.inputattrsSmall}
                  name={EventInfoFields.CENTER_CERTNUMBER}
                  buttonid={EventInfoFields.CENTER_CERTNUMBER + '-search'}
                  type='number'
                  buttondisabled={(isEmpty(centercertnumber) || searchMode)}
                  disabled={(!isAdministrator && (status == StatusDescription.Completed || status == StatusDescription.Canceled)) || (saveComponentState === true)}
                  placeholder='Type center certificaction number'
                  component={renderInputWithSearchField}
                  onsearch={this.onHandleGetCenterInfoByNumber}
                  loading={searchMode}
                  onChange={this.handleResetEventLocation}
                  className='no-spinners'
                />
                <Field
                  label='Center Name'
                  labelattrs={style.lblattrs}
                  inputattrs={style.inputattrsSmall}
                  name={EventInfoFields.CENTER_NAME}
                  buttonid={EventInfoFields.CENTER_NAME + '-search'}
                  buttondisabled={(isEmpty(centername) || searchMode)}
                  disabled={(!isAdministrator && (status == StatusDescription.Completed || status == StatusDescription.Canceled)) || (saveComponentState === true)}
                  placeholder='Type center name (min 3 characters long)'
                  component={renderInputWithSearchField}
                  onsearch={this.onHandleGetCenterInfo}
                  loading={searchMode}
                  onChange={this.handleResetEventLocation}
                />
                <Field
                  label='Country'
                  labelattrs={style.lblattrs}
                  inputattrs={style.inputattrs}
                  name={EventInfoFields.EVENT_COUNTRY}
                  id={EventInfoFields.EVENT_COUNTRY}
                  component={renderOptionsField}
                  values={countries}
                  defaultvalue={eventcountry}
                  disabled={(!isAdministrator && (status == StatusDescription.Completed || status == StatusDescription.Canceled)) || (saveComponentState === true)}
                />
                <Field
                  label='Address'
                  labelattrs={style.lblattrs}
                  inputattrs={style.inputattrs}
                  name={EventInfoFields.EVENT_ADDRESS}
                  component={renderField}
                  disabled='disabled'
                />
                <Field
                  label='City'
                  labelattrs={style.lblattrs}
                  inputattrs={style.inputattrs}
                  name={EventInfoFields.EVENT_CITY}
                  component={renderField}
                  disabled='disabled'
                />
                {eventcountry == 'US' && (<Field
                  label='State'
                  labelattrs={style.lblattrs}
                  inputattrs={style.inputattrs}
                  name={EventInfoFields.EVENT_STATE}
                  component={renderSelectField}
                  values={states}
                  disabled
                />)}
                {eventcountry == 'CA' && (<Field
                  label='Province'
                  labelattrs={style.lblattrs}
                  inputattrs={style.inputattrs}
                  name={EventInfoFields.EVENT_STATE}
                  component={renderSelectField}
                  values={canadianprovinces}
                />)}
                <Field
                  label={eventcountry == 'US' ? 'Zip Code' : 'Postal Code'}
                  labelattrs={style.lblattrs}
                  inputattrs={style.inputattrs}
                  name={EventInfoFields.EVENT_ZIPCODE}
                  component={renderField}
                  disabled='disabled'
                />
                <FormGroup style={{ height: '6px', padding: '0', margin: '0' }}>
                  <span>{' '}</span>
                </FormGroup>
              </Col>
            )
          }
          {

            (<Col md={12} lg={6} style={{ border: `1px solid ${gray}`, borderLeftWidth: '0', padding: '15px' }}>
              <FormGroup style={{ padding: '0 0 15px 25px', margin: '0' }}>
                <h4 className='text-left' style={{ color: blue }}>{' '}Director Information</h4>
              </FormGroup>
              {
                nomembersfound !== undefined && nomembersfound &&
                <span className={spanClassName} style={{ color: warning, float: 'left' }}>
                  <i className='fa fa-info-circle' style={{ paddingLeft: '0px', marginTop: '0px' }} />&nbsp;&nbsp;Athlete not found
                        </span>
              }
              <FormGroup>
                <label className={style.lblattrsWide}>USBC Member ID</label>
                <Col sm={3} md={3} lg={3}>
                  <Field
                    className="form-control no-spinners"
                    placeholder='Prefix (#)'
                    component="input"
                    type='number'
                    name={EventInfoFields.MEMBERID_PREFIX}
                    onChange={this.handleResetEventDirector}
                    onKeyDown={this.handleNegativeNumbers}
                    onKeyUp={this.handleNotToExceedLengthPrefix}
                    disabled={(!isAdministrator && (status == StatusDescription.Completed || status == StatusDescription.Canceled)) || (saveComponentState === true)}
                  />
                </Col>
                <Col sm={3} md={3} lg={4} style={{ marginLeft: '-28px', minWidth: '130px' }}>
                  <Field
                    className="form-control no-spinners"
                    placeholder='Suffix (#)'
                    component="input"
                    type='number'
                    name={EventInfoFields.MEMBERID_SUFFIX}
                    onChange={this.handleResetEventDirector}
                    onKeyDown={this.handleNegativeNumbers}
                    onKeyUp={this.handleNotToExceedLengthSuffix}
                    disabled={(!isAdministrator && (status == StatusDescription.Completed || status == StatusDescription.Canceled)) || (saveComponentState === true)}
                  />
                </Col>
                <Col sm={1} lg={1} md={1}>
                  <span className="input-group-btn" sm={1} md={1} lg={1}>
                    <button
                      type="button"
                      className="btn btn-default"
                      id='button'
                      style={
                        {
                          marginLeft: '-32px', marginTop: '-1px', minHeight: '37px', maxWidth: '41px',
                          borderRadius: '0', color: orange
                        }
                      }
                      onClick={this.handleGetMemberInfo}
                      disabled={isEmpty(memberidprefix) || isEmpty(memberidsuffix) || (!isAdministrator && (status == StatusDescription.Completed || status == StatusDescription.Canceled))}>

                      <i className={searchMode === true ? "fa fa-spinner fa-spin" : "fa fa-search"} aria-hidden="true" />
                    </button>
                  </span>
                </Col>
              </FormGroup>
              <Field
                label='Name'
                name={EventInfoFields.DIRECTOR_NAME}
                labelattrs={style.lblattrsWide}
                inputattrs={style.inputattrsSmall}
                component={renderField}
                disabled='disabled'
              />
              <Field
                label='Email'
                name={EventInfoFields.DIRECTOR_SSOEMAIL}
                type='email'
                labelattrs={style.lblattrsWide}
                inputattrs={style.inputattrsSmall}
                component={renderField}
                disabled='disabled'
              />
              <Field
                label='Event Email'
                name={EventInfoFields.EVENT_EMAIL}
                type='email'
                labelattrs={style.lblattrsWide}
                inputattrs={style.inputattrsSmall}
                component={renderField}
                disabled={(!isAdministrator && (status == StatusDescription.Completed || status == StatusDescription.Canceled)) || (saveComponentState === true)}
              />
              <Field
                label='Phone Number'
                labelattrs={style.lblattrsWide}
                inputattrs={style.inputattrxsmall}
                name={EventInfoFields.DIRECTOR_PHONE}
                component={renderField}
                normalize={normalizePhone}
                disabled={(!isAdministrator && (status == StatusDescription.Completed || status == StatusDescription.Canceled)) || (saveComponentState === true)}
              />
              <Field
                label='Country'
                labelattrs={style.lblattrsWide}
                inputattrs={style.inputattrsSmall}
                name={EventInfoFields.DIRECTOR_COUNTRY}
                id={EventInfoFields.DIRECTOR_COUNTRY}
                component={renderOptionsField}
                values={countries}
                defaultvalue={directorcountry}
                disabled={(!isAdministrator && (status == StatusDescription.Completed || status == StatusDescription.Canceled)) || (saveComponentState === true)}
              />
              <Field
                label='Address Line 1'
                labelattrs={style.lblattrsWide}
                inputattrs={style.inputattrsSmall}
                name={EventInfoFields.DIRECTOR_ADDRESS1}
                component={renderField}
                disabled={(!isAdministrator && (status == StatusDescription.Completed || status == StatusDescription.Canceled)) || (saveComponentState === true)}
              />
              <Field
                label='Address Line 2'
                labelattrs={style.lblattrsWide}
                inputattrs={style.inputattrsSmall}
                name={EventInfoFields.DIRECTOR_ADDRESS2}
                component={renderField}
                disabled={(!isAdministrator && (status == StatusDescription.Completed || status == StatusDescription.Canceled)) || (saveComponentState === true)}
              />
              <Field
                label='City'
                labelattrs={style.lblattrsWide}
                inputattrs={style.inputattrsSmall}
                name={EventInfoFields.DIRECTOR_CITY}
                component={renderField}
                disabled={(!isAdministrator && (status == StatusDescription.Completed || status == StatusDescription.Canceled)) || (saveComponentState === true)}
              />
              <Field
                label='State'
                labelattrs={style.lblattrsWide}
                inputattrs={style.inputattrsSmall}
                name={EventInfoFields.DIRECTOR_STATE}
                component={renderSelectField}
                values={countrystates}
                disabled={(!isAdministrator && (status == StatusDescription.Completed || status == StatusDescription.Canceled)) || (saveComponentState === true)}
              />
              <Field
                label='Zip Code'
                labelattrs={style.lblattrsWide}
                inputattrs={style.inputattrsSmall}
                name={EventInfoFields.DIRECTOR_ZIPCODE}
                component={renderField}
                disabled={(!isAdministrator && (status == StatusDescription.Completed || status == StatusDescription.Canceled)) || (saveComponentState === true)}
              />
            </Col>
            )
          }
        </form>
      </div>)
  }
}
EventInfo.propTypes = {
  handleSubmit: PropTypes.func,
  dispatch: PropTypes.func,
  setCenter: PropTypes.func,
  setSearchMode: PropTypes.func,
  fetchEvent: PropTypes.func,
  fetchMember: PropTypes.func,
  fetchActiveSeasons: PropTypes.func,
  resetEventLocation: PropTypes.func,
  resetEventDirector: PropTypes.func,
  saveEventInfo: PropTypes.func,
  resendEventEmail: PropTypes.func,
  resendingEventEmail: PropTypes.func,
  anyTouched: PropTypes.bool,
  eventId: PropTypes.number,
  eventname: PropTypes.string,
  centercertnumber: PropTypes.number,
  centername: PropTypes.string,
  startdate: PropTypes.string,
  enddate: PropTypes.string,
  eventaddress: PropTypes.string,
  fetchCenter: PropTypes.func,
  setCorrectEventInfo: PropTypes.func,
  eventcity: PropTypes.string,
  eventstate: PropTypes.string,
  eventzipcode: PropTypes.string,
  eventcountry: PropTypes.string,
  usbcmemberid: PropTypes.string,
  eventInfoIsCorrect: PropTypes.bool,
  change: PropTypes.func,
  eventseason: PropTypes.string,
  norecordsfound: PropTypes.bool,
  searchMode: PropTypes.bool,
  centers: PropTypes.array,
  memberidsuffix: PropTypes.string,
  memberidprefix: PropTypes.string,
  directorname: PropTypes.string,
  eventemail: PropTypes.string,
  directorssoemail: PropTypes.string,
  directorphone: PropTypes.string,
  directorcountry: PropTypes.string,
  directoraddress1: PropTypes.string,
  directoraddress2: PropTypes.string,
  directorcity: PropTypes.string,
  directorstate: PropTypes.string,
  directorzipcode: PropTypes.string,
  seasons: PropTypes.array,
  savingData: PropTypes.bool,
  isEventInfoVerified: PropTypes.bool,
  eventVerificationEmailSent: PropTypes.bool,
  resendingemail: PropTypes.bool,
  info: PropTypes.object,
  prestineinfo: PropTypes.object,
  oidc: PropTypes.object,
  user: PropTypes.object,
  saveComponentState: PropTypes.bool,
  onComponentStateSaved: PropTypes.func,
  componentStateSaved: PropTypes.bool,
  currentWizardStep: PropTypes.number,
  updateErrors: PropTypes.object,
  nomembersfound: PropTypes.bool,
  roleName: PropTypes.string,
  status: PropTypes.string
}

function mapStateToProps(state, ownProps) {

  const formName = ownProps.form
  const selector = formValueSelector(formName)
  const eventId = selector(state, 'eventId')
  const centercertnumber = selector(state, 'centercertnumber')
  const centername = selector(state, 'centername')
  const eventname = selector(state, 'eventname')
  const eventaddress = selector(state, EventInfoFields.EVENT_ADDRESS)
  const eventcity = selector(state, EventInfoFields.EVENT_CITY)
  const eventstate = selector(state, EventInfoFields.EVENT_STATE)
  const eventzipcode = selector(state, EventInfoFields.EVENT_ZIPCODE)
  const eventcountry = selector(state, 'eventcountry')
  const usbcmemberid = selector(state, 'usbcmemberid')
  const eventseason = selector(state, 'eventseason')
  const startdate = selector(state, 'startdate')
  const enddate = selector(state, 'enddate')
  const norecordsfound = selector(state, 'norecordsfound')
  const searchMode = selector(state, 'searchMode')
  const centers = selector(state, 'centers')
  const memberidprefix = selector(state, EventInfoFields.MEMBERID_PREFIX)
  const memberidsuffix = selector(state, EventInfoFields.MEMBERID_SUFFIX)
  const directorname = selector(state, EventInfoFields.DIRECTOR_NAME)
  const eventemail = selector(state, EventInfoFields.EVENT_EMAIL)
  const directorssoemail = selector(state, EventInfoFields.DIRECTOR_SSOEMAIL)
  const directorphone = selector(state, EventInfoFields.DIRECTOR_PHONE)
  const directorcountry = selector(state, EventInfoFields.DIRECTOR_COUNTRY)
  const directoraddress1 = selector(state, EventInfoFields.DIRECTOR_ADDRESS1)
  const directoraddress2 = selector(state, EventInfoFields.DIRECTOR_ADDRESS2)
  const directorcity = selector(state, EventInfoFields.DIRECTOR_CITY)
  const directorstate = selector(state, EventInfoFields.DIRECTOR_STATE)
  const directorzipcode = selector(state, EventInfoFields.DIRECTOR_ZIPCODE)
  const seasons = selector(state, 'seasons')
  const anyTouched = selector(state, 'anyTouched')
  const savingData = selector(state, 'savingData')
  const currentWizardStep = selector(state, 'currentWizardStep')
  const info = selector(state, 'info')
  const prestineinfo = selector(state, 'prestineinfo')
  const componentStateSaved = selector(state, 'componentStateSaved')
  const updateErrors = selector(state, 'updateErrors')
  const nomembersfound = selector(state, 'nomembersfound')
  const status = selector(state, 'status')
  const roleName = state.user.roleName
  return {
    eventId,
    eventname,
    anyTouched,
    centercertnumber,
    centername,
    startdate,
    enddate,
    eventaddress,
    eventcountry,
    eventcity,
    eventstate,
    eventzipcode,
    usbcmemberid,
    eventseason,
    norecordsfound,
    searchMode,
    centers,
    memberidprefix,
    memberidsuffix,
    directorname,
    eventemail,
    directorssoemail,
    directorphone,
    directorcountry,
    directoraddress1,
    directoraddress2,
    directorcity,
    directorstate,
    directorzipcode,
    seasons,
    savingData,
    currentWizardStep,
    info,
    prestineinfo,
    oidc: state.oidc,
    user: state.user,
    componentStateSaved,
    updateErrors,
    nomembersfound,
    roleName,
    status
  }
}
function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    fetchEvent,
    fetchCenter,
    fetchMember,
    fetchActiveSeasons,
    saveEventInfo,
    resetWizardState,
    resetEventLocation,
    resetEventDirector,
    setSearchMode,
    setCenter,
  }, dispatch)
}
export default reduxForm({
  form: FormName,
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: false
})(connect(mapStateToProps, mapDispatchToProps)(EventInfo))



// WEBPACK FOOTER //
// ./src/containers/event/components/eventInfo/index.js